module.exports = __webpack_public_path__ + "img/virtual_tour.a13985b6.jpg";